import { Box, Typography } from '@mui/material';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { formatSeriesDate } from '~/utils/date';
import { cutUID } from '~/utils/string';
import type { RegistrationTargetImage } from './registrationTargetImage';

/**
 * One image's identity: series description, then modality, slice count,
 * series date and a shortened series UID.
 */
export default function TargetImageIdentity({
    image,
}: {
    image: RegistrationTargetImage;
}) {
    const date = formatSeriesDate(image.date);
    return (
        <Box width="100%" overflow="hidden">
            <SensitiveInfoTypography>
                <Typography
                    component="span"
                    display="block"
                    color="white"
                    fontSize={image.label ? 14 : 13}
                    fontStyle={image.label ? 'normal' : 'italic'}
                    noWrap
                >
                    {image.label || 'No series description'}
                </Typography>
            </SensitiveInfoTypography>
            <Box display="flex" gap={0.5} alignItems="baseline">
                <Typography variant="body2" fontSize={12} color="textSecondary">
                    {image.modality}
                </Typography>
                {image.sliceCount != null && (
                    <Typography variant="body2" fontSize={12} color="primary">
                        ({image.sliceCount})
                    </Typography>
                )}
                {date && (
                    <Typography
                        variant="body2"
                        fontSize={12}
                        color="textSecondary"
                    >
                        <SensitiveInfoTypography>
                            {date}
                        </SensitiveInfoTypography>
                    </Typography>
                )}
                <Typography variant="body2" fontSize={12} color="textSecondary">
                    <SensitiveInfoTypography>
                        {cutUID(image.seriesId, 4, 4)}
                    </SensitiveInfoTypography>
                </Typography>
            </Box>
        </Box>
    );
}
